import Vue from 'vue';

export default {
    getRegions(context, useCache) {
        return new Promise((resolve, reject) => {
            if (useCache) {
                console.log("Using cached version if available");
                let regions = context.getters.getRegions;
                if (regions !== undefined && regions.length !== 0) {
                    console.log("Returning regions from storage")
                    return resolve(regions);
                }
                console.log("No regions available in cache, fetching")
            }
            context.commit('setFetchingRegions', true)
            Vue.prototype.$http({
                method: 'GET',
                url: '/regions'
            }).then(res => {
                let regions = res.data;
                console.log("Fetched regions correctly");

                context.commit('setRegions', regions);
                resolve(regions);
            }).catch(err => {
                console.error("Could not fetch regions!")
                console.log(err)
                reject(err);
            }).finally(() => {
                context.commit('setFetchingRegions', false);
            });
        });
    },
    getHouseTypes(context, useCache) {
        return new Promise((resolve, reject) => {
            if (useCache) {
                console.log("Fetching House Types from cache, if available");
                let houseTypes = context.getters.getHouseTypes;
                if (houseTypes !== undefined && houseTypes.length !== 0) {
                    console.log("Returning house types from storage")
                    return resolve(houseTypes);
                }
                console.log("No house types available from cache, fetching");
            }
            // TODO: Does this need a commit to communicate the state?
            Vue.prototype.$http({
                method:'GET',
                url: '/types'
            }).then(res => {
                let houseTypes = res.data;
                console.log("Fetched house types correctly")
                context.commit('setHouseTypes', houseTypes);
                resolve(houseTypes);
            }).catch(err => {
                console.error("Could not fetch house types!");
                console.log(err);
                reject(err);
            });
        })
    },


    login({ commit }, user) {
        return new Promise((resolve, reject) => {
          commit('auth_request');
      
          Vue.prototype.$http.post('/login', user)
            .then((res) => {
              console.log("Login API Response:", res.data); // Debugging line
      
              if (!res.data.token) {
                console.error("No token received from API!");
                commit('auth_error');
                reject("No token in response");
                return;
              }
      
              const token = res.data.token;
              localStorage.setItem('token', token);
      
              console.log("Stored token in localStorage:", localStorage.getItem("token"));
      
              Vue.prototype.$http.defaults.headers.common.Authorization = `Bearer ${token}`;
              commit('auth_success', token);
              resolve(res);
            })
            .catch(err => {
              console.error("Login failed:", err);
              commit('auth_error');
              reject(err);
            });
        });
      },      
      
      logout({ commit }) {
        return new Promise((resolve) => {
          commit('logout');
          localStorage.removeItem('token');
          delete Vue.prototype.$http.defaults.headers.common.Authorization;
          resolve();
        });
      },
      checkAuth({ commit }) {
        const token = localStorage.getItem('token');
        if (token) {
          commit('auth_success', token);
        } else {
          commit('logout');
        }
      },
}